// extracted by mini-css-extract-plugin
module.exports = {"synopsis":"tCKCr","syncontent":"WEwSo","readMore":"bVjCU","innercont":"M1rHh","expanded":"vkpDP","doubledot_heading":"faiOF","readLess":"dCqjM","mweb-articleshow":"VPExT"};